/**
 * Fenice Italy Business API
 * # Fenice Italy Business API  ## General Http Status: HTTP STATUS CODE | DESCRIPTION --- | --- 400 | Business error or general error 401 | Expired token 403 | Access token does not have the required scope 404 | Not found 500 | Internal error  ## Specific Error Codes: Verti has specific errors based on validations, in error field *code*  CODE | DESCRIPTION --- | --- KOIT001 | Plate not valid from SIC/SITA. KOIT002 | Vehicle plate number is not valid. KOIT003 | Login failed. Password is not correct.  ## Annotations:   - In those services that return a list of items, in the case of not found any of them, it will return an empty list.   - For date format, standard ISO 8601. (YYYY-MM-DDThh:mm:ss.sTZD)
 *
 * OpenAPI spec version: 1.2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CurrencyIsoCode } from './currencyIsoCode';
import { DeductibleDetail } from './deductibleDetail';
import { PremiumDetail } from './premiumDetail';
import { PremiumDiff } from './premiumDiff';
import { Prestazione } from './prestazione';
import { RfsOption } from './rfsOption';
import { SumInsuredDetail } from './sumInsuredDetail';

export interface Coverage {
  /**
   * coverage code
   */
  coverageId?: string;
  /**
   * coverage title
   */
  coverageTitle?: string;
  /**
   * coverage detailed description. It will be shown in the tooltip
   */
  coverageDesc?: string;
  currencyIsoCode?: CurrencyIsoCode;
  /**
   * Sum insured detail. (Indennizzo)
   */
  sumInsuredDetail?: SumInsuredDetail;
  /**
   * It is true if the coverage is required in the commercial product
   */
  requiredInd?: boolean;
  /**
   * Insured deductible. (Franchigia)
   */
  deductibleDetail?: DeductibleDetail;
  /**
   * List of associated coverages.
   */
  associatedCoverages?: Array<Coverage>;
  premiumDetail?: PremiumDetail;
  premiumDiff?: PremiumDiff;
  /**
   * Category of the coverage. Used to group and filter the coverages
   */
  coverageCategoryCode?: string;
  /**
   * Category name of the coverage. This field will be shown.
   */
  coverageCategoryDesc?: string;
  rfsOption?: RfsOption;
  suspensionOption?: RfsOption;
  premiumRFS?: PremiumDetail;
  prestazioni?: Array<Prestazione>;
}
